import $ from 'jquery'
import { ready } from 'shared/ready'
import Faq from '../components/faq'
import { throttle } from 'lodash'

class AiBuilderView {
  constructor($el) {
    if ($el.length === 0) return

    new Faq({
      root: $el.find('.home__faq'),
      classes: {
        seen: 'home__faq--seen',
        question: 'home__question',
        opened: 'home__question--opened',
        content: 'home__question-content',
      },
    })

    this.$aiBuilderCta = $el.find('.builder-ai__hero-button')
    this.$menuCta = $('#build_resume')

    this.initialMenuCtaContent = this.$menuCta.html()

    if (this.$aiBuilderCta.length) {
      $(window).on('scroll', throttle(this.handleScroll.bind(this), 250))
    }
  }

  handleScroll() {
    if ($(window).scrollTop() > 0) {
      this.$menuCta.addClass('builder-ai__hero-button-color')
      this.$menuCta.html('Create with AI')
    } else {
      this.$menuCta.removeClass('builder-ai__hero-button-color')
      this.$menuCta.html(this.initialMenuCtaContent)
    }
  }
}

// ---
// Init
// ---
ready(function () {
  return new AiBuilderView($('.ai-builder'))
})
